<template>
  <!-- 实名认证 -->
  <div class="con">
    <van-action-sheet v-model="show" @close="close">
      <div class="content">
        <div class="top_bg">
          <div class="font_title1 font12 font_weight500 colof line_height_17">
            海关要求
          </div>
          <div class="font_title font18 font_weight500 line_height_25 colof">
            购买跨境商品需要实名认证
          </div>
          <img
            src="@/assets/order/icon_id_close@2x.png"
            alt=""
            class="icon_close"
            @click="close"
          />
        </div>
        <div class="con_con">
          <div class="font12 font_weight400 colo087 text_left">
            请填写实名信息，并使用实名人的账户付款：
          </div>
          <van-field
            v-model="preCheckout.idcardName"
            name="姓    名"
            label="姓    名"
            placeholder="请输入您的真实姓名"
            :rules="[{ required: true, message: '请填写姓名' }]"
            @input="inputName"
          />
          <van-field
            v-model="preCheckout.idcardNo"
            name="身份证"
            label="身份证"
            placeholder="请输入您的身份证号"
            :rules="[{ required: true, message: '请填写身份证' }]"
            @input="inputId"
          />
          <div
            class="font14 font_weight500 colof line_height_40 btn"
            @click="sure"
          >
            确认
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: true,
      username: "",
      idNum: ""
    };
  },
  computed: {
    preCheckout() {
      return this.$store.getters.preCheckout;
    }
  },
  methods: {
    close() {
      this.show = true;
      this.$emit("closeSheet");
    },
    sure() {
      this.show = true;
      this.$emit("closeSheet");
      this.$emit("sure");
    },
    inputName(name) {
      this.$emit("inputName", name);
    },
    inputId(id) {
      this.$emit("inputId", id);
    }
  }
};
</script>

<style lang="less" scoped>
.con {
  ::v-deep .van-popup {
    background-color: transparent !important;
  }
  .top_bg {
    background: url("../../../../../assets/order/id_bg@2x.png") 0 0 no-repeat;
    background-size: 100% 100%;
    position: relative;
    .font_title1 {
      padding-top: 3px;
    }
    .font_title {
      padding: 19px 0 35px;
    }
    .icon_close {
      position: absolute;
      top: 13px;
      right: 10px;
      width: 24px;
    }
  }
  .con_con {
    background: #fff;
    padding: 12px;
    ::v-deep .van-cell {
      background: #edeeef;
      border-radius: 19px;
      padding: 9px 16px;
      margin: 18px 0 12px;
    }
    ::v-deep .van-field__label {
      width: 70px;
      margin-right: 0;
    }
  }
  .btn {
    background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
    border-radius: 20px;
  }
}
</style>
